<script>
import api from '@/helpers/api'

export default {
  props: {
    customerId: {
      required: true,
      type: String
    },
    page: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: -1
    }
  },

  data: () => ({
    isLoading: false,
    items: [],
    totalRows: 0
  }),

  methods: {
    async refresh () {
      this.isLoading = true
      let { items, total_rows } = await api.customerAddresses.fetchPage({
        page: this.page,
        pageSize: this.pageSize,
        filters: [{ customer_id: { _eq: this.customerId } }]
      })

      this.isLoading = false
      this.items = items.map(i => {
        const { alias, is_active, address, customer_id } = i
        return {
          alias,
          is_active,
          customer_id,
          ...address
        }
      })
      this.totalRows = total_rows

      return this.items
    }
  },

  mounted () {
    this.refresh()
  },

  render () {
    return this.$scopedSlots.default({
      items: this.items,
      totalRows: this.totalRows,
      isLoading: this.isLoading
    })
  }
}
</script>
